











import { Vue, Component } from "@/shared/vuepack";
import { useUserStore } from "@/shared/store/user";

@Component
export default class CurrentEmployer extends Vue {

  userStore = useUserStore();

  get isLoggedInAsPartner () {
    return this.userStore.currentPartner;
  }

  get showPartnerText () {
    return this.isLoggedInAsPartner && this.$route.params.partnerId;
  }

  get showEmployerText () {
    return !this.isLoggedInAsPartner && this.userStore.currentEmployer && !this.$route.params.partnerId;
  }

  get currentEmployerDisplayName () {
    return this.userStore.currentEmployer && this.userStore.currentEmployer.employerName;
  }
}
